import { FaVideoSlash } from "react-icons/fa";
import styled from "styled-components";

const VideoOffWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  align-items: center; 
  justify-content: center; 
  width: 100%;
  height: 100%;
  position: relative;
  gap: 16px;
  border-radius: 8px;
  color: black ;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.205);
`;

const Message = styled("span")`
  text-align: center;
  font-size: 18px;
  font-weight: 500;
`;

interface VideoOffIndicatorProps {
  message?: string;
}

const VideoOffIndicator = ({ message }: VideoOffIndicatorProps) => {
  return (
    <VideoOffWrapper>
      {message ? <Message>{message}</Message> : <FaVideoSlash size={35} />}
    </VideoOffWrapper>
  );
};

export default VideoOffIndicator;
